import React from "react";

function AboutNL() {
  return <div>About</div>;
}

export default AboutNL;
